import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

type BooleanSelect = {
  label?: string;
  onChange: (val?: boolean) => void;
  value?: boolean;
  error?: string;
};

export const BooleanSelect = ({ label, onChange, value, error }: BooleanSelect) => {
  const { t } = useTranslation();

  const actualValue = useMemo(() => {
    switch (value) {
      case true:
        return "true";
      case undefined:
        return "undefined";
      case false:
        return "false";
    }
  }, [value]);

  return (
    <FormControl fullWidth>
      <InputLabel>{label}</InputLabel>
      <Select
        label={label}
        size="small"
        variant="outlined"
        value={actualValue}
        onChange={(e) => {
          const newValue = e.target.value;
          if (newValue === "true") {
            onChange(true);
            return;
          }
          if (newValue === "false") {
            onChange(false);
            return;
          }
          onChange(undefined);
        }}
        error={!!error}
      >
        <MenuItem value="true" selected={value === true}>
          {t("true")}
        </MenuItem>
        <MenuItem value="false" selected={value === false}>
          {t("false")}
        </MenuItem>
        <MenuItem value="undefined" selected={value === undefined}>
          {t("none")}
        </MenuItem>
      </Select>
    </FormControl>
  );
};
